import { render, staticRenderFns } from "./GDatePickerEx.vue?vue&type=template&id=83dc6772&scoped=true&"
import script from "./GDatePickerEx.vue?vue&type=script&lang=ts&"
export * from "./GDatePickerEx.vue?vue&type=script&lang=ts&"
import style0 from "./GDatePickerEx.vue?vue&type=style&index=0&id=83dc6772&lang=scss&scoped=true&"
import style1 from "./GDatePickerEx.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dc6772",
  null
  
)

export default component.exports